import React , { useState, useEffect, useRef } from 'react';
import {styled , keyframes}from 'styled-components';
import { MdEmail , MdPhone,MdLocationOn} from 'react-icons/md'; 
import { FaWhatsapp , FaGraduationCap} from 'react-icons/fa';


function Main() {
   const [visible, setVisible] = useState(true);
  const lastScrollY = useRef(0);

 useEffect(() => {
  let ticking = false;

  const handleScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        const currentScrollY = window.scrollY;
        if (Math.abs(currentScrollY - lastScrollY.current) > 5) {
          if (currentScrollY > lastScrollY.current) {
            setVisible(false);
          } else {
            setVisible(true);
          }
        }
        lastScrollY.current = currentScrollY;
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', handleScroll);
  return () => window.removeEventListener('scroll', handleScroll);
}, []);

const skills = [
  { icon: '🌐', text: ' Web Applications: I have experience in web programming, using both frontend and backend technologies.I build responsive interfaces with HTML, CSS, JavaScript, and React.On the backend, I use Python with Flask to develop applications.' },
  { icon: '📱', text: 'Mobile Applications: I have experience in mobile application development using Flutter with Dart to build cross-platform apps.I also used Java to develop native Android applications with efficient performance and UI control. ' },
  { icon: '🤖', text: 'Artificial Intelligence: I developed a graduation project applying artificial intelligence using deep machine learning techniques to classify different types of dates.The project utilized TensorFlow, one of the most popular libraries, to build and train the classification model efficiently.' },
  { icon: '🔧', text: 'Embedded Systems: I have hands-on experience working on various projects using Arduino, ESP32, and Raspberry Pi.Most of these projects were personal initiatives focusing on embedded systems and IoT applications.' },
  { icon: '🛠️', text: 'Device Maintenance: I have sufficient experience in repairing electronic devices such as mobile phones and computer .I am skilled in troubleshooting electronic circuits and general electrical maintenance' },
  { icon: '🖨️', text: '3D Printing: I have experience working with 3D printers and building projects using Blender software.Skilled in creating detailed 3D models and preparing them for printing' }
];

const Contact =[
  { icon: <MdEmail style={{  fontSize: '23px' }} />, text: (<><strong title='Send Email don`t be scared'>Email: </strong> azooz51894@gmail.com</>) },
  { icon: <MdPhone style={{ fontSize: '23px' }} />,text: (<><strong title='Call me don`t be scared'>Phone: </strong>+966567903881</>)},
  { icon: <MdLocationOn style={{ fontSize: '23px' }} />, text: (<><strong title='came here don`t be scared'>Adrress: </strong>Mdinah, Saudi Arabia</>) },]
  
  return (
   <MainDiv >

   {/**Top navBar*/}

   <DivbarMain >

   <MsinName>ABDULAZIZ 🖥️</MsinName>

   <DivInsideMain  >
      <Navbar>
    <AnavTop href='#about' >About</AnavTop>
    <AnavTop href='#skills' >Skills</AnavTop>
    <AnavTop href='#contact' >Contact</AnavTop>

    
   </Navbar>
   <EventConteiner visible={visible}>
   
    <Img  src='/photo_5967355049585789586_y.jpg'>

    </Img>
    <TextFullNmae >Abdulaziz Aljohani</TextFullNmae>
    
   </EventConteiner>
   
   </DivInsideMain>
   </DivbarMain>


  {/**second main*/}

  <DivSecondMain id='about' >

   <DivInSideSecondMain>
   <NmaeSecandMain>About me </NmaeSecandMain>
   <TextContainer >
   <ImageContainer>
     <Img2 src='/photo_5967355049585789587_y.jpg'/>
     <IconBox>
      <FaGraduationCap style={{ fontSize: '50px' }} />
     </IconBox>
   </ImageContainer>
    
    <InformationAboutMe> I am Abdulaziz Aljohani, a 2025 graduate from Taibah University with a Bachelor’s degree in Computer Science.
I have a strong passion for technology and software development. I am always eager to improve my skills and contribute to innovative projects.</InformationAboutMe>
   </TextContainer>
  </DivInSideSecondMain>


  </DivSecondMain>

  {/**third main*/}

  <DivThirdMain id='skills'>

  <DivInSideThirdMain>
  <NmaeThirdMain> Skills </NmaeThirdMain>
  <InformationThirdMain>I have developed a range of skills throughout my academic journey at the university, especially in programming and problem-solving.
In addition to my coursework, I dedicated time to learning new technologies and improving my abilities independently.
This mix of academic learning and self-driven exploration has shaped me into a well-rounded and motivated learner.
</InformationThirdMain>
 <CardContainer>
  {skills.map((skill, index) => (
    <IconBox1 key={index}>
      <span style={{ fontSize: '2rem' }}>{skill.icon}</span>
      <TextCard>{skill.text}</TextCard>
    </IconBox1>
  ))}
</CardContainer>
 </DivInSideThirdMain>

  </DivThirdMain>
  
{/** fourth main*/}
  <DivForthMain id='contact'>
    <DivInSideForthMain>
    <NmaeForthMain>Contact</NmaeForthMain>
    <InformationForthMain> Feel free to contact me regarding any job opportunities.
I'm open to roles where I can grow and contribute my skills.</InformationForthMain>

  <CardContainerForContact>
  
  <IconBoxForContact>
  <NmaeCardForContact>Contact Information</NmaeCardForContact>
  <InsidCardForContact>
  {Contact.map((contact, index) => (
    <ContactRow key={index}>
      <IconBoxContect>{contact.icon}</IconBoxContect>
      <TextCardForContact>{contact.text}</TextCardForContact>
    </ContactRow>
  ))}
</InsidCardForContact>

  </IconBoxForContact>
  <IconBoxForContact>
    
   <NmaeCardForContact2>WhatsApp</NmaeCardForContact2>

  <WhatsAppButton href="https://wa.me/966567903881" target="_blank">
    <WhatsAppIcon>🟢</WhatsAppIcon>
    <span>Abdulaziz Aljohani</span>
  </WhatsAppButton>
  </IconBoxForContact>
 
</CardContainerForContact>

    </DivInSideForthMain>
  </DivForthMain>

  {/**bottom bar*/}
  <DivBottomBar>
 <DivBottomBarInside>

 <InfBottomBar>ABDULAZIZ 🖥️</InfBottomBar>
 <BottomConteiner>

    <a href='#about' style={{ textDecoration: 'none', color: 'white' ,fontSize:'17px'}} >About</a>
    <a href='#skills' style={{ textDecoration: 'none', color: 'white',fontSize:'17px' }} >Skills</a>
    <a href='#contact' style={{ textDecoration: 'none', color: 'white',fontSize:'17px' }} >Contact</a>

    
   
 </BottomConteiner>
 <Line></Line>
 <BottomTextOfBar>© {new Date().getFullYear()} Abdulaziz Aljohani. All Rights Reserved.</BottomTextOfBar>
 </DivBottomBarInside>
  </DivBottomBar>

   </MainDiv>
      
      
  );
}




//css code ***********************************************************************************/
const MainDiv = styled.div`

min-height: 600vh;

background-color:inherit;
scroll-behavior: smooth;
 
`;

const DivbarMain = styled.div`
height: 100vh;
width: 100%;
  background-image: url(https://picfiles.alphacoders.com/510/thumb-1920-510791.jpg);
  backdrop-filter: blur(80px);
  background-size: cover;
  background-color: inherit;


  @media (max-width: 768px) {
    width: auto;
    height: 90vh;
    background-size: cover;
    object-fit: cover;
   
   
  }
`;

const DivInsideMain = styled.div`
 
display: flex;
flex-wrap: wrap;
justify-content: center;
align-items: center;
flex-direction: column;
height: 100%;

transition: transform 4s ease, opacity 0.40s ease;
z-index: 1000;
box-shadow: 0 2px 4px rgba(43, 43, 43 ,0.1);



`;

const EventConteiner = styled.div`
display: flex;
flex-wrap: wrap;
justify-content: center;
align-items: center;
flex-direction: column;
height: 100%;
scrollbar-width: none;
transition: transform 4s ease, opacity 0.40s ease;
z-index: 1000;
box-shadow: 0 2px 4px rgba(43, 43, 43 ,0.1);

 transition: transform 3s ease, opacity 0.6s ease;
  transform: ${({ visible }) => (visible ? 'translateY(0)' : 'translateY(-100%)')};
  opacity: ${({ visible }) => (visible ? '1' : '0')};
`;
const Img = styled.img`
border-radius: 58%;
object-fit: cover;
 object-position: 50% 30%;
width: 180px;
height: 180px;


 @media (max-width: 768px) {
  border-radius: 58%;
    width: 150px;
    height: 150px;
   
   
  }

`;

const Navbar = styled.nav`
position: fixed;
display: flex;
flex-direction: row;
gap: 30px;
right: 10px;
top: 18px;
font-family: 'Lora' serif;
 z-index: 999;

 @media (max-width: 768px) {
    font-size: small;
    gap: 17px;
    top: 18px;
    
   
   
  }

`;
const AnavTop = styled.a`
color: white;
text-decoration: none;
font-family: 'Lora' serif;
 scroll-margin-top: 100px;


`;
const TextFullNmae = styled.p`
color: white;
font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif ;
font-size: 25px;




 @media (max-width: 768px) {
    font-size: large;
    font-weight: bold;
    font-family: 'Lora' serif;
   
   
  }
`;
const MsinName = styled.a`
position: absolute;
color: white;
margin: 10px;
top: 5px;
font-weight: bold;
font-size: 25px;
font-family: 'Lora' serif;

 @media (max-width: 768px) {
    font-size: medium;
    font-weight: bold;
    font-family:' Lora', serif;
   
  }
`;

{/* second main CSS */}

const DivSecondMain = styled.div`
background-color: #faf9f9;
height: 90%;
background-image: url('/59887.png');

background-repeat: repeat;        
  background-size: 300px 300px;   
  background-position: center;     
  background-blend-mode: overlay;
  


 @media (max-width: 768px) {
    width: auto;
    height: 120vh;
   
    
  }
`;
const DivInSideSecondMain = styled.div`
display: flex;

justify-content: center;
align-items: center;
flex-direction: column;
scrollbar-width: none;

gap: 10vh;


`;
const NmaeSecandMain = styled.h1`
  color: black;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: inline-block;
  
  border-bottom: 2px solid rgba(0, 0, 0, 0.6); 
  padding-bottom: 1px; 
`;

const TextContainer = styled.div` 
  display: contents;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 110px;
  padding-right: 300px;
  position: relative;
  left: 150px;
 
  

   @media (max-width: 768px) {
    left: 100px;
    bottom: 40px;
    flex-direction: column;
    
    
   
   
  }


`;

const ImageContainer = styled.div`
  position: relative;
  width: fit-content;
  
`;
const Img2 = styled.img`
border-radius: 1%;
object-fit: cover;
width: 400px;
height: 500px;
@media (max-width: 768px) {
    width: 300px;
    height: 400px;
    top: 20px;

   
  }

 
`;
const InformationAboutMe= styled.p`
  position: relative;
  color: black;
  font-size: 24px;
  line-height: 1.4;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  text-align: center;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  word-spacing: 1.6px;
  font-family: 'Lora' serif;
 

@media (max-width: 768px) {
    font-size: large;
    display: grid;
    place-items: center;
    text-align: center;
    margin: 0 20px;
    line-height: 1.2;
    font-weight: bold;
    word-spacing: 2px;
    padding-top: 20px;
    
  }

`;
const IconBox = styled.span`
  background-color: black;
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 10px;
  right: 10px;
  background: black;
  color: white;
  padding: -10px;
  border-radius: 50%;
  font-size: 50px;
  display: flex;
  
  @media (max-width: 768px) {
    position: absolute;
    width: 50px;
    height:50px;
    
    bottom: 10px;
    left: 10px;
  }

`;

{/*css third main*/}

const DivThirdMain = styled.div`
height: 170vh;
background-color:rgb(255, 255, 255);

 @media (max-width: 768px) {
    height: 240vh;
  }

`; 

const DivInSideThirdMain = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
scrollbar-width: none;
gap: 90px;
 @media (max-width: 768px) {
    
    gap: 45px;
    
  }
`;
const NmaeThirdMain = styled.h1`
  color: black;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: inline-block;
  position: relative; 
  border-bottom: 2px solid rgba(0, 0, 0, 0.6); 
  padding-bottom: 1px; 
  gap: 30px;

`;
const InformationThirdMain = styled.p`
 position: relative;
  color: black;
  font-size: 20px;
  line-height: 1.4;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  text-align: center;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  word-spacing: 1.6px;

  @media (max-width: 768px) {
    font-size: small;
    
    
  }
  
`;
const CardContainer = styled.div`
  display: flex;
  flex-direction: row; 
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap; 

 @media (max-width: 768px) {
    
    gap: 30px;
    
  }


`;

const IconBox1 = styled.span`
  background-color: #f1f1f1;
  width: 200px;
  height: 200px;
  
  color: white;
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 10px;
  text-align: center;

  transition: transform 0.3s ease;
 
  box-shadow: 0 4px 10px rgba(88, 88, 88, 0.79);
  
  `;

  const TextCard = styled.p`
  margin-top: 1px;
  font-size: 14px;
  color: black;
`;

{/*css forth main*/}

const DivForthMain = styled.div`
height: 160vh;
background-color: #f0f4f8;

 @media (max-width: 768px) {
    height: 200vh;
  }
  @media (min-width: 1000px) {
    height: 216vh; 
  }
`;

const DivInSideForthMain = styled.div`
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
scrollbar-width: none;
gap: 90px;

`;
const flash = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;
const NmaeForthMain = styled.h1`
  color: black;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: inline-block;
  position: relative;
  border-bottom: 3px solid rgba(0, 0, 0, 0.6); 
  padding-bottom: 4px; 
  gap: 50px;
  font-size: 40px;

  
   &::after {
    content: 'OpenToWork'; 
    position: absolute;
    right: -50px;
    color:rgb(189, 49, 49);
    rotate: -30deg;
    font-size: 18px;
    right: 80px;
    animation: ${flash} 0.9s infinite;
  }



  &:hover::after {
    opacity: 1;
  }
  `;



const InformationForthMain = styled.p`
  position: relative;
  color: black;
  font-size: 20px;
  line-height: 1.4;
  display: flex;
  justify-content: center;
  margin-top: 20px;
  text-align: center;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
  word-spacing: 1.6px;

  @media (max-width: 768px) {
    font-size: small;
    
    
  }
`;

const CardContainerForContact = styled.div`
 display: flex;
  flex-direction: row; 
  justify-content: center;
  align-items: center;
  gap: 30px;
  flex-wrap: wrap; 

 @media (max-width: 768px) {
    
    gap: 30px;
    
  }
`;

const IconBoxForContact = styled.span`
background-color: #edf2f7;
  width: 500px;
  height: 530px;
  
  color: white;
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  padding: 10px;
  text-align: center;

  transition: transform 0.3s ease;

 
  box-shadow: 0 4px 10px rgba(185, 208, 241, 0.79);

  &:hover {
    background-color:rgba(211, 211, 211, 0.1);
  }
  @media (max-width: 768px) {
    
    width: 300px;
   
    
  }


`;
const NmaeCardForContact = styled.h1`
  color: black;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: inline-block;
  border-bottom: 1px solid rgba(0, 0, 0, 0.6); 
  padding-bottom: 2px; 
  gap: 1px;
  position: relative;
  bottom: 60px ;
  font-size: 24px;
`;
const InsidCardForContact = styled.div`
  display: flex;
  flex-direction: column; 
  justify-content: center;
  align-items: flex-start;
  gap: 30px;
  margin-top: 50px;
  margin-right: 100px;
  
  
`;
const ContactRow = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
   @media (max-width: 768px) {
    
    position: relative;
    left: 40px;
    gap: 10px;
    
  }
`;
const IconBoxContect = styled.span`
  background-color: black;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 18px;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const TextCardForContact = styled.p`
 color: black;
  margin: 0;
  font-size: 20px;

   @media (max-width: 768px) {
    
    font-size: small;
   
  white-space: nowrap;

    
  }
`;


const NmaeCardForContact2 = styled.h1`
  color: black;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  display: inline-block;
  border-bottom: 1px solid rgba(0, 0, 0, 0.6); 
  padding-bottom: 2px; 
  gap: 1px;
  position: relative;
  bottom: 180px ;
  font-size: 24px;
`;
const WhatsAppButton = styled.a`
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #25D366; 
  color: white;
  text-decoration: none;
  padding: 12px 20px;
  border-radius: 50px;
  font-size: 16px;
  font-weight: bold;
  transition: background-color 0.3s;
  cursor: pointer;

  &:hover {
    background-color:rgb(2, 5, 3);
  }
`;



const WhatsAppIcon = styled(FaWhatsapp)`
  font-size: 24px;
`;

{/*bottom bar css*/}

const DivBottomBar = styled.div`
background-color: black;
height: 50vh;

@media (max-width: 768px) {
    height: 30vh;
   
  }
`;
const DivBottomBarInside = styled.div`

display: flex;
flex-wrap: wrap;
justify-content: center;
align-items: center;
flex-direction: column;
height: 100%;
@media (max-width: 768px) {
  
}


`;
const InfBottomBar = styled.a`
color: white;
position: relative;
bottom: 70px ;
font-weight: bold;
font-size: 25px;
font-family: 'Lora' serif;

 @media (max-width: 768px) {
    font-size: medium;
    font-weight: bold;
    font-family:' Lora', serif;
    bottom: 30px;
   
  }
`;
const BottomConteiner = styled.div`
display: flex;
flex-direction: row;
color:  white;
gap: 90px;
position: relative;


 @media (max-width: 768px) {
    gap: 50px;
    
   
  }
`;

const Line = styled.div`
 width: 350px; 
  height: 1px;
  background-color: white;
  margin-top: 30px;

  @media (max-width: 768px) {
    width: 230px; 
  }
`;
const BottomTextOfBar = styled.p`
position: relative;
color: white;
font-size: 14px;
font-family: 'Lora' serif;
top: 30px;
`;
//*******************************************************************************************/


export default Main;
